export const employerType = {
    practice:"Practices",
    facility:"Facilities"
};

